<template>
  <div class="quick-list">
    <div class="head">
      <div class="logo" @click="urlto('/')" style="cursor: pointer;">
        <img :src="platform.cut_bclip" alt="">
      </div>
      <div class="headright">
        <img class="user-img" :src="info.logo" alt="" v-if="info.logo">
        <img class="user-img" src="../../assets/img/user-icon.png" alt="" v-else>
        <span class="user-name">{{ info.username }}</span>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap-t">
        <div class="classify item">
          <div class="title">
            <strong>分类：</strong>
          </div>
          <ul class="nav-item">
            <li :class="{ active: cate == item }" @click="select_cate(item)" v-for="item in cates">{{ item }}</li>
          </ul>
        </div>
        <div class="color item">
          <div class="title">
            <strong>颜色：</strong>
          </div>
          <ul class="nav-item">
            <li :class="{ active: color == item }" @click="select_color(item)" v-for="item in colors">{{ item }}</li>
          </ul>
        </div>
        <div class="item end-item">
          <div class="left">
            <!-- <div class="direction">
              <div class="title">
                <strong>方向：</strong>
              </div>
              <ul class="nav-item">
                <li :class="{active: isActive3==1}" @click="select3(1)">全部</li>
                <li :class="{active: isActive3==2}" @click="select3(2)">横屏</li>
                <li :class="{active: isActive3==3}" @click="select3(3)">竖屏</li>
              </ul>
            </div> -->
            <!-- <div class="sort">
              <div class="title">
                <strong>排序：</strong>
              </div>
              <ul class="nav-item">
                <li :class="{ active: isActive4 == 1 }" @click="select4(1)">销量</li>
                <li :class="{ active: isActive4 == 2 }" @click="select4(2)">最新</li>
              </ul>
            </div> -->
          </div>
          <div class="right">
            <!-- <a href="">视频教学</a> -->
            <!-- <el-button class="btn">AI脚本</el-button> -->
            <!-- <el-button class="btn">一键成品</el-button> -->
          </div>

        </div>

      </div>
    </div>
    <div class="templates" v-loading="loading" element-loading-background="#2b2b2b">
      <ul class="templates-list">
        <li class="item" v-for="item in table" :key="item.id">
          <div class="imagebox">
            <img :src="item.url" alt="">
            <div class="fake">
              <el-button class="btn" @click="urlopen('/clip/quickcut', { tcode: item.code })">快剪</el-button>
            </div>
          </div>
          <p class="tit">{{ item.name }}</p>
          <div class="serial">编号：{{ item.code }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getPlatform, getUserinfo } from '../../assets/js/common'
import paltform from '../../assets/js/paltform.json'
export default {
  data() {
    return {
      isActive: '全部',
      isActive2: 1,
      isActive3: 1,
      isActive4: 1,
      table: null,
      loading: true,
      cate: "全部",
      color: "全部",
      cates: ["全部", "婚纱庆典", "人设打造", "酒店住宿", "游玩展馆", "教育培训", "休闲娱乐", "户外旅游", "农业产品", "工业设备", "材料配件", "数码家电", "服装箱包", "食品饮料", "建筑家装"],
      colors: ["全部", "粉红", "紫色", "灰色", "黄色", "蓝色", "黑色", "多彩"],
      platform: {},
      info: {},
    }
  },
  methods: {
    select_cate(v) {
      this.cate = v;
      this.query();
    },
    select_color(v) {
      this.color = v;
      this.query();
    },
    query() {
      this.loading = true;
      this.$get('/template/list', { cate: this.cate, color: this.color }).then(res => {
        this.table = res.data;
      }).finally(r => {
        this.loading = false;
      })
    },
    //跳转
    urlto(router, params) {
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    urlopen(router, params) {
      var res = this.$router.resolve({
        path: router,
        query: params
      });
      window.open(res.href, '_blank');
    },
  },
  created() {
    this.platform = getPlatform();
    this.info = getUserinfo();
    let platjson = this.$linq.from(paltform).firstOrDefault(w => w.id == this.info.plat);
    document.getElementById("icon").href = platjson.icon;
    this.query();
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

.quick-list {
  box-sizing: border-box;
  padding: 40px 8vw;
  margin: 0 auto;
  background-color: #2b2b2b;
  color: #fff;
  height: auto;
  min-height: 100vh;
}

.quick-list .wrap .wrap-t>.item {
  display: flex;
  padding: 20px 0;
}

.quick-list .wrap .item:nth-child(-n+3) {
  border-bottom: 1px dashed #424245;
}

.quick-list .wrap .wrap-t>.item .title {
  width: 60px;
  font-size: 16px;
  padding: 9px 4px 9px 0;
  white-space: nowrap;
}

.quick-list .wrap .wrap-t>.item .nav-item {
  display: flex;
  flex-wrap: wrap;
}

.quick-list .wrap .wrap-t>.item .nav-item li {
  cursor: pointer;
  font-size: 14px;
  color: #fff;

  margin: 5px;
  padding: 9px 15px;
  transition: all 0.4s ease;
  display: inline-block;
  border-radius: 3px;
  white-space: nowrap;
}

.quick-list .wrap .wrap-t>.item .nav-item li.active {
  color: #fff;
  background-color: #006cff;

}

.quick-list .wrap .wrap-t .end-item {
  justify-content: space-between;
  align-items: center;
  border-bottom: none;

}

.quick-list .wrap .wrap-t .end-item .left {
  display: flex;
  align-items: center;
}

.quick-list .wrap .wrap-t .end-item .left>div {
  display: flex;
  align-items: center;
  margin-right: 60px;
}

.quick-list .wrap .wrap-t .end-item .right a {
  color: #fff;
  font-size: 12px;
  text-decoration: underline;

}

.quick-list .wrap .wrap-t .end-item .right .btn {
  padding: 7px 15px;
  color: #fff;
  background-color: #006cff;
  font-size: 12px;
  border: #006cff;
  margin-left: 10px;
}

.templates {
  margin-top: 40px;
}

.templates .templates-list {
  display: flex;
  flex-wrap: wrap;
}

.templates .templates-list .item {
  width: 19.2%;
  margin-bottom: 20px;
  margin-right: 1%;
}

.templates .templates-list .item:nth-child(5n) {
  margin-right: 0;
}

.templates .templates-list .item .imagebox {
  width: 100%;
  position: relative;
  cursor: pointer;
}

.templates .templates-list .item .imagebox img {
  display: block;
  border-radius: 4px;
  max-width: 100%;
}

.templates .templates-list .item .imagebox .fake {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, .5);
  opacity: 0;
  z-index: -1;
  transition: all .3s ease;
}

.templates .templates-list .item .imagebox .fake .btn {
  color: #fff;
  background-color: #006cff;
  border-color: #006cff;
  padding: 12px 20px;
}

.templates .templates-list .item:hover .imagebox .fake {
  opacity: 1;
  z-index: 1;
}

.templates .templates-list .item .tit {
  margin: 20px 0 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.templates .templates-list .item .serial {
  color: rgba(136, 136, 136, 1);
  text-align: center;
}

@media screen and (max-width:1280px) {
  .templates .templates-list .item {
    width: 24%;
    margin-bottom: 20px;
    margin-right: 1%;
  }

  .templates .templates-list .item:nth-child(4n) {
    margin-right: 0;
  }

  .templates .templates-list .item:nth-child(5n) {
    margin-right: 1%;
  }
}

@media screen and (max-width:1024px) {
  .quick-list .wrap .wrap-t .end-item {
    flex-wrap: wrap;
  }

  .quick-list .wrap .wrap-t .end-item .left {
    width: 100%;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
}

@media screen and (max-width:750px) {
  .templates .templates-list {
    justify-content: space-between;
  }

  .templates .templates-list .item {
    width: 49%;
    margin-bottom: 20px;
    margin-right: 0%;
  }

  .templates .templates-list .item:nth-child(5n) {
    margin-right: 0%;
  }
}

@media screen and (max-width:500px) {
  .quick-list[data-v-ca251cc6] {
    padding: 30px 20px;
  }
}

.head {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.head .headright {
  display: flex;
  align-items: center;
}

.head .headright .user-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
}

.logo {
  margin-bottom: 20px;
  width: 250px;
}
</style>